import { useZakekeHelpers } from '@zakeke/zakeke-customizer-react';
import { debounce } from 'lodash';

const useWaitUntilItemRerenderStops = () => {
	const { addRenderedElementListenerOnce } = useZakekeHelpers();

	return async (guids: string[]) => {
		const waitUntilItemRerenderStop = (guid: string) => {
			let completed = false;
			return new Promise((resolve) => {
				const complete = debounce(() => {
					completed = true;
					resolve(null);
				}, 300);
				const listener = () =>
					addRenderedElementListenerOnce(guid, () => {
						complete();
						if (!completed) {
							listener();
						}
					});
				addRenderedElementListenerOnce(guid, listener);
			});
		};
		const waitUntilItemsRerenderStops = (guids: string[]) => {
			return Promise.all(guids.map(waitUntilItemRerenderStop));
		};
		await waitUntilItemsRerenderStops(guids);
	};
};

export default useWaitUntilItemRerenderStops;
